/**
 * Extract specific properties from an object.
 *
 * @param {[]} props - Specific properties wanted from object.
 * @param {object} obj - Original object
 * @returns  {object} Output to object with the specify properties.
 */

export function getObjectProps(
  props: { key: string; accessor: string }[],
  obj: object,
): {} {
  const formatProps = props.map(
    (property: { key: string; accessor: string }) => {
      if (/\./.test(property.accessor)) {
        return { key: property.key, accessor: property.accessor.split('.') };
      }
      return property;
    },
  );

  return formatProps.reduce((acc, item) => {
    if (Array.isArray(item.accessor)) {
      // TODO: recursive function for nested properties
      acc[item.key] = obj[item.accessor[0]][item.accessor[1]];
      return acc;
    }

    acc[item.key] = obj[item.accessor];
    return acc;
  }, {});
}
